import Router from "next/router";
import { useCallback, useEffect } from "react";

type ReturnValues = {
  forcePageTransition: (url: string) => void;
};

// formに何かしら値が入っていたらページ離脱させないhook
// SEE: https://stackoverflow.com/questions/63064778/next-js-warn-user-for-unsaved-form-before-route-change
const useStopPageTransition = (
  shouldStop: boolean,
  exceptionalUrls: Array<string>,
  onStopPageTransition: () => Promise<boolean>
): ReturnValues => {
  const routeChangeStart = useCallback(
    (url: string) => {
      const urlWithoutQuery = url.split("?")[0];

      if (shouldStop && !exceptionalUrls.includes(urlWithoutQuery)) {
        continueTransition(url);

        Router.events.emit("routeChangeError");
        throw "Abort route change. Please ignore this error.";
      }
    },
    [shouldStop]
  );

  const continueTransition = async (url: string) => {
    const continues = await onStopPageTransition();

    if (continues) {
      forcePageTransition(url);
    }
  };

  const removeListeningEvents = () => {
    Router.events.off("routeChangeStart", routeChangeStart);
  };

  const forcePageTransition = (url: string) => {
    removeListeningEvents();
    Router.replace(url);
  };

  useEffect(() => {
    Router.events.on("routeChangeStart", routeChangeStart);

    return () => {
      removeListeningEvents();
    };
  }, [shouldStop, routeChangeStart]);

  return { forcePageTransition };
};

export default useStopPageTransition;
